import * as Lambda from './LambdaApi';

const sendTextMessage = async (text, residentId) => {
    try {
        const apiPath = `/residents/${residentId}/stories`;
        const payloadObject = { text };
        const res = await Lambda.Post(apiPath, payloadObject, 'lambda');
        return res && res.success;
        // return Promise.reject()
    } catch (error) {
        return false;
    }
};

const sendAudioMessage = async (audioId, residentId) => {
    try {
        const apiPath = `/residents/${residentId}/stories`;
        const payloadObject = { audioId };
        const res = await Lambda.Post(apiPath, payloadObject, 'lambda');
        return res && res.success;
    } catch (error) {
        return false;
    }
};
const sendVideoMessage = async (videoId, residentId) => {
    try {
        const apiPath = `/residents/${residentId}/stories`;
        const payloadObject = { videoId };
        const res = await Lambda.Post(apiPath, payloadObject, 'lambda');
        return res && res.success;
    } catch (error) {
        return false;
    }
};
const sendImageMessage = async (imageId, text, audioId, residentId) => {
    try {
        const apiPath = `/residents/${residentId}/stories`;
        const payloadObject = text ? { imageId, text }: {imageId, audioId};
        const res = await Lambda.Post(apiPath, payloadObject, 'lambda');
        return res && res.success;
    } catch (error) {
        return false;
    }
};
const getSettings = async (residentId) => {
    try {
        const apiPath = `/residents/${residentId}/story-settings`;
        const settings = await Lambda.Get(apiPath, {}, 'lambda');
        return settings;
    } catch (error) {
        return false;
    }
};

const putSettings = async (residentId, period) => {
    try {
        const apiPath = `/residents/${residentId}/story-settings`;
        const payloadObject = {
            ...period,
        };
        const updateResponse = await Lambda.Put(apiPath, payloadObject, 'lambda');
        if (!updateResponse.success) return false;
        return updateResponse;
    } catch (error) {
        return false;
    }
};

const getMessages = async (residentId, limit) => {
    try {
        let params = {};

        if (limit) params = { queryStringParameters: { limit } };

        const apiPath = `/residents/${residentId}/stories`;
        const getMessageResponse = await Lambda.Get(apiPath, params, 'lambda');
        if (!getMessageResponse.success) return false;
        return getMessageResponse.stories;
    } catch (error) {
        return false;
    }
};

const putMessage = async (residentId, storyId, text) => {
    try {
        const apiPath = `/residents/${residentId}/stories/${storyId}`;
        const payloadObject = { text };
        const putMessage = await Lambda.Put(apiPath, payloadObject, 'lambda');
        if (!putMessage.success) return false;
        return putMessage.story;
    } catch (error) {
        return false;
    }
};

const deleteMessage = async (residentId, storyId) => {
    try {
        const apiPath = `/residents/${residentId}/stories/${storyId}`;
        const deleteMessageResponse = await Lambda.Delete(apiPath, {}, 'lambda');
        if (!deleteMessageResponse.success) return false;
        return true;
    } catch (error) {
        return false;
    }
};

const getUploadUrl = async (ext = 'wav') => {
    try {
        const apiPath = '/audio-stories';
        const params = {queryStringParameters :{ ext }}
        const response = await Lambda.Get(apiPath, params, 'lambda');

        if (!response.success) return false;

        return response;
    } catch (err) {}
};

const uploadToSignedUrl = async (blob, url) => {
    const params = {
        method: 'PUT',
        body: blob,
    };

    return fetch(url, params);
};

export {
    sendTextMessage,
    getSettings,
    putSettings,
    getMessages,
    putMessage,
    deleteMessage,
    getUploadUrl,
    uploadToSignedUrl,
    sendAudioMessage,
    sendImageMessage,
    sendVideoMessage
};
